import type { ICellRendererParams } from 'ag-grid-community';
import { formatDateTime, formatRelativeTime } from '@utils/format';
import type { ForecastRun } from '../../schema';

// Two-line cell: absolute timestamp + relative ("3h ago"). Mirrors the
// updated-at cell convention used everywhere else.
export function StartedAtCell(p: ICellRendererParams<ForecastRun>) {
  if (!p.data) return null;
  return (
    <div className="flex flex-col leading-tight">
      <span className="text-[13px] font-semibold text-foreground">
        {formatDateTime(p.data.startedAt)}
      </span>
      <span className="mt-0.5 text-[11px] text-foreground-muted">
        {formatRelativeTime(p.data.startedAt)}
      </span>
    </div>
  );
}
